export default __webpack_public_path__ + "static/media/download_xls.0dac9a74.svg";